import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Creators as PrivacyPolicyCreators } from '../../store/ducks/privacyPolicy';
import Loading from '../../components/Loading';

class PoliticaDePrivacidade extends Component {
  static propTypes = {
    getPrivacyPolicyRequest: PropTypes.func.isRequired,
    privacyPolicy: PropTypes.string.isRequired,
  };

  componentWillMount() {
    this.props.getPrivacyPolicyRequest();
  }

  render() {
    if (this.props.privacyPolicy.loading) {
      return <Loading />;
    }

    return (
      <Fragment>
        <div
          className="text-box text-justify"
          dangerouslySetInnerHTML={{ __html: this.props.privacyPolicy.privacy_policy }}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  privacyPolicy: state.privacyPolicy,
});

const mapDispatchToProps = dispatch => bindActionCreators(PrivacyPolicyCreators, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PoliticaDePrivacidade);



// WEBPACK FOOTER //
// ./src/pages/politicaDePrivacidade/index.js